module.exports = __webpack_public_path__ + "img/undraw_travel_plans_li01.56d51a68.svg";